module.exports = __webpack_public_path__ + "img/flutter.f5014de5.png";